export default {
  dayString : function(date){
    console.log(date)
    return this.getDay(date) + ", "+ this.getMonth(date) + " " + date.getUTCDate() + ", " + date.getFullYear()
  },
  getDay : function(date){
    let day = ""

    switch (date.getUTCDay()) {
      case 0:
        day = "Sun"
        break
      case 1:
        day = "Mon"
        break
      case 2:
        day = "Tues"
        break
      case 3:
        day = "Weds"
        break
      case 4:
        day = "Thurs"
        break
      case 5:
        day = "Fri"
        break
      case 6:
        day = "Sat"
        break
    }

    return day
  },
  getMonth : function(date){
    let month = ""
    switch (date.getUTCMonth()) {
      case 0:
        month = "January"
        break
      case 1:
        month = "February"
        break
      case 2:
        month = "March"
        break
      case 3:
        month = "April"
        break
      case 4:
        month = "May"
        break
      case 5:
        month = "June"
        break
      case 6:
        month = "July"
        break
      case 7:
        month = "August"
        break
      case 8:
        month = "September"
        break
      case 9:
        month = "October"
        break
      case 10:
        month = "November"
        break
      case 11:
        month = "December"
        break
    }
    return month
  },
}
